module.exports = __webpack_public_path__ + "img/计数模式.b60a502b.jpg";